import {useAuth} from '../../../../../app/modules/auth'
import {AdminMenu} from './AdminMenu'
import {ParentMenu} from './ParentMenu'

export function MenuInner() {
  const {currentUser} = useAuth()
  const pos = currentUser?.position
  return (
    <>
      {pos !== 'Lecturer' && pos !== 'Student' && pos !== 'Parent' && <AdminMenu />}
      {pos === 'Parent' && <ParentMenu />}
    </>
  )
}
